/**
 * 路由名称常量
 * 统一管理所有路由名称，避免硬编码
 */
export const RouteNames = {
  Company: 'Company',
  CompanyAgent: 'CompanyAgent',
  AccountCenter: 'AccountCenter',
  Switch: 'Switch'
} as const

/**
 * 导出路由名称类型
 */
export type RouteName = typeof RouteNames[keyof typeof RouteNames]
